import { Directive, Output, EventEmitter, ElementRef, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { OutsideEventDirective } from './outside-event.directive';

@Directive({
  selector: '[wfmOutsideContextMenu]'
})
export class OutsideContextMenuDirective extends OutsideEventDirective {
  @Output() wfmOutsideContextMenu: EventEmitter<any>;

  constructor(@Inject(DOCUMENT) document, element: ElementRef) {
    super(document, element, 'contextmenu');
    this.wfmOutsideContextMenu = this.wfmOutsideEvent;
  }
}
